<!--
 * @Author: gang.liu
 * @Date: 2021-06-28 09:21:02
 * @LastEditTime: 2021-06-29 15:29:05
 * @LastEditors: gang.liu
 * @Description:
 * @api-property:
 * @api-event:
 * @api-method:
-->
<template>
  <div class="bg-primary px-8 py-4 text-white" v-if="showflag">
    <div class="mb-1">
      <span class="cursor-pointer">关于我们</span
      >&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
<!--      <el-popover-->
<!--        placement="top-start"-->
<!--        width="430"-->
<!--        trigger="hover"-->
<!--      >-->
<!--        <div style="background-color:#35a8a4;">-->
<!--          <div style="background-color:#35a8a4;padding: 10px 0">-->
<!--            <img src="@/assets/contactus.png" alt="">-->
<!--          </div>-->
<!--          <div style="height: 10px;background-color: #fff;"></div>-->
<!--          <img src="@/assets/themap.png" alt="">-->
<!--          <div style="background-color:#fff;padding: 10px;font-size: 15px;font-weight: bold;">-->
<!--            <p>联系电话：010-5367 2266</p>-->
<!--            <p>服务时间：周一至周五（8：30-17：00）</p>-->
<!--            <p>地址：北京市海淀区北三环西路32号恒润国际大厦602室</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <span slot="reference" class="cursor-pointer">联系我们</span>-->
<!--      </el-popover>-->
<!--      <span class="cursor-pointer" @click="$router.push({path:'/contactUs'})">联系我们</span>-->
<!--      &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;-->
<!--      <span class="cursor-pointer" @click="$router.push({path:'/partners'})">合作伙伴</span>-->
<!--      <span class="cursor-pointer">联系我们</span>-->
<!--      &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;-->
<!--      <span class="cursor-pointer">合作伙伴</span>-->
      <span class="cursor-pointer" @click="$router.push({path:'/contactUs'})">联系我们</span>
      <!-- &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; -->
      <!-- <span class="cursor-pointer" @click="$router.push({path:'/partners'})">合作伙伴</span> -->
    </div>
    <div class="text-sm">
      Copyright @ 2018 北京归源易生软件开发有限公司 All Right Reserved |
      药品医疗器械网络信息服务备案 （京）网药械信息备字（2025）第00380号 | 增值电信业务经营许可证 
      京B2-20210041 |
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
        >京ICP备17070131号</a
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showflag: true,
      visible: false
    };
  },
  created() {
    if (this.$route.path == "/register" && this.browserRedirect() == "phone") {
      this.showflag = false;
    }
  },
  watch: {
    $route(to, from) {
      console.log(to.path, from.path);
      if (to.path == "/register" && this.browserRedirect() == "phone") {
        this.showflag = false;
      }
    },
  },
  methods: {
    browserRedirect() {
      let sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      let bIsMidp = sUserAgent.match(/midp/i) == "midp";
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      let bIsAndroid = sUserAgent.match(/android/i) == "android";
      let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        return "phone";
      } else {
        return "pc";
      }
    },
  },
};
</script>
<style lang="less" scoped>
// .gy-footer {
//   height: 130px;
//   background-color: #35a8a4;
//   padding: 40px;
//   color: #fff;
//   &-link {
//     font-size: 18px;
//     margin-bottom: 10px;
//     span {
//       cursor: pointer;
//     }
//   }
//   &-copyright {
//     font-size: 13px;
//   }
// }
</style>
